export default "__VITE_ASSET__BfGdq_S4__"